module.exports = __webpack_public_path__ + "static/img/dog.3e6563a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dog.jpg
// module id = oNMg
// module chunks = 4